import PropertyDetailChangelog from './PropertyDetailChangelog';

export default PropertyDetailChangelog;
